import { o_util } from "../../common/namespaces";
import { assignNamespace } from "../../common/namespace-utils";
import { get as getCookie } from "../cookie/get.js";
import { COOKIE_PREFIX, cookieMap, normalize, rawToggles } from "./normalize.js";

/**
 *
 *
 *
 *
 */
export type GetToggleResult<T> = [value: true, payload: T] | [value: false, payload: undefined];

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function getToggle<T = never>(
  toggleName: string,
  defaultValue: boolean,
): GetToggleResult<T | undefined>;
export function getToggle<T = never>(
  toggleName: string,
  defaultValue: boolean,
  defaultPayload: T,
): GetToggleResult<T>;
export function getToggle<T = never>(
  toggleName: string,
  defaultValue = true,
  defaultPayload = undefined as T,
): GetToggleResult<T> {
  const rawToggle = rawToggles[toggleName];

  /*                                                              */
  const [value, overrideAllowed, payload] = normalize(rawToggle, defaultValue, defaultPayload);

  /*                                                      */
  if (!overrideAllowed) return [value, payload as never];

  /*                             */
  const localOverride = getCookie<keyof typeof cookieMap>(COOKIE_PREFIX + toggleName);

  /*                                                                      */
  if (!localOverride || cookieMap[localOverride] === undefined) return [value, payload as never];

  /*                    */
  return [!!cookieMap[localOverride], payload as never];
}

/**
 *
 *
 *
 *
 *
 *
 *
 */
export function get(toggleName: string, defaultValue = false): boolean {
  const [res] = getToggle(toggleName, defaultValue, undefined);
  return res;
}

/*                    */
assignNamespace(o_util, "toggle", { get, getToggle });
